/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/pages/auth/AuthPage`, `src/pages/home/HomePage`).
 */

import React, { lazy, Suspense } from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { useLastLocation } from "react-router-last-location";
import { LayoutContextProvider } from "../../_metronic";
import Layout from "../../_metronic/layout/Layout";
import * as routerHelpers from "../router/RouterHelpers";

const HomePage             = lazy(() => import("../pages/home/HomePage"));
const ErrorsPage           = lazy(() => import("../pages/errors/ErrorsPage"));
const LogoutPage           = lazy(() => import("../pages/auth/Logout"));
const AuthPage             = lazy(() => import("../pages/auth/AuthPage"));
const Inventory            = lazy(() => import("../pages/inventory/inventory"));
const Pos                  = lazy(() => import("../pages/pos/pos"));
const PosEmp               = lazy(() => import("../pages/pos/posEmp"));
const CommingSoon          = lazy(() => import("../pages/errors/commingSoon"));
const Orders               = lazy(() => import("../pages/orders/orders"));
const UnCompleteOrder      = lazy(() => import("../pages/orders/unCompleteOrder"));
const BuyCards             = lazy(() => import("../pages/orders/buyCards"));
const OrdersList           = lazy(() => import("../pages/orders/ordersList"));
const Tools                = lazy(() => import("../pages/tools/tools"));
const RequestOrder         = lazy(() => import("../pages/RequestOrder/RequestOrder"));
const DaftraOrder          = lazy(() => import("../pages/orders/daftraOrder"));
const DaftraInventory      = lazy(() => import("../pages/inventory/daftraInventory"));
const DaftraEmp            = lazy(() => import("../pages/pos/daftraEmp"));
const Receipt              = lazy(() => import("../pages/pos/receipt"));
const MyOrdersPOS          = lazy(() => import("../pages/orders/MyOrdersPOS"));
const POSBuyCards          = lazy(() => import("../pages/orders/POSbuyCards"));
const ChangePasswordWrapper = lazy(() => import("../pages/auth/ChangePasswordWrapper"));
const LangPage             = lazy(() => import("../pages/LangPage/LangPage"));

export const Routes = withRouter(({ history }) => {
  const lastLocation = useLastLocation();
  routerHelpers.saveLastLocation(lastLocation);
  const { isAuthorized, menuConfig, userLastLocation } = useSelector(
    ({ auth, urls, builder: { menuConfig } }) => ({
      menuConfig,
      isAuthorized:
        localStorage.getItem("USER_ID") != "" &&
          localStorage.getItem("USER_ID") != undefined &&
          localStorage.getItem("USER_ID") != null
          ? true
          : false,
      userLastLocation: routerHelpers.getLastLocation(),
    }),
    shallowEqual
  );

  return (
    <LayoutContextProvider history={history} menuConfig={menuConfig}>
      <Suspense fallback={<div />}>
        <Switch>
          <Route
            path="/ar"
            render={(props) => <LangPage {...props} key={1} lang={1} />}
          />
          <Route
            path="/en"
            render={(props) => <LangPage {...props} key={2} lang={2} />}
          />
          <Route path="/logout" component={LogoutPage} />

          {!isAuthorized ? (
            <AuthPage />
          ) : (
            <Redirect from="/auth" to={userLastLocation} />
          )}

          <Route path="/error" component={ErrorsPage} />
          <Route
            path="/password/changePassword"
            component={ChangePasswordWrapper}
          />
          <Route
            path="/pages/inventory/:mainDist?/:posId?"
            component={Inventory}
          />
          <Route path="/pages/pos" component={Pos} />
          <Route path="/pages/distributors" component={Pos} />

          <Route path="/pages/posEmp/:pageType?" component={PosEmp} />
          <Route path="/pages/commingSoon" component={CommingSoon} />
          <Route path="/pages/orders" component={Orders} />
          <Route path="/pages/ordersList" component={OrdersList} />
          <Route path="/pages/buyCards" component={BuyCards} />
          <Route path="/pages/unCompleteOrder" component={UnCompleteOrder} />
          <Route path="/pages/tools" component={Tools} />
          <Route path="/pages/RequestOrder" component={RequestOrder} />

          <Route path="/pages/daftraOrder" component={DaftraOrder} />
          <Route path="/pages/daftraInventory" component={DaftraInventory} />
          <Route path="/pages/daftraEmp" component={DaftraEmp} />
          <Route path="/pages/receipt/:posId?" component={Receipt} />

          {!isAuthorized ? (
            <Redirect to="/auth/login" />
          ) : (
            <Layout>
              <HomePage userLastLocation={userLastLocation} />
            </Layout>
          )}
        </Switch>
      </Suspense>
    </LayoutContextProvider>
  );
});
